import React, { useEffect, useState } from "react";
import { useHttpClient } from "../../../../shared/hooks/http-hook";

import { useLoading } from "../../../../shared/context/LoadingContext";
import FiltrosRelatorio from "../ui/filtrosRelatorio/FiltrosRelatorio";
import RelatorioProcedimentosCategoria from "./components/RelatorioProcedimentosCategoria";
import RelatorioEficienciaMedicos from "./components/RelatorioEficienciaMedicos";
import RelatorioProcedimentosPendentes from "./components/RelatorioProcedimentosPendentes";
import RelatorioProcedimentosMedico from "./components/RelatorioProcedimentosMedico";
import RelatorioDiario from "./components/RelatorioDiario";
import RelatorioContabilidadeAnalitica from "./components/RelatorioContabilidadeAnalitica";
import RelatorioProcedimentosExecutados from "./components/RelatorioProcedimentosExecutados";

import toast from "react-hot-toast";

const tiposRelatorios = [
  { value: "", label: "Selecione um relatório" },
  // {
  //   value: "procedimento-categoria",
  //   label: "Relatório de categorias de procedimentos",
  // },
  // { value: "eficiencia-medicos", label: "Eficiência dos Médicos" },
  // { value: "procedimentos-pendentes", label: "Procedimentos Pendentes" },
  // {
  //   value: "procedimentos-medico",
  //   label: "Procedimentos Executados por Médico",
  // },
  {
    value: "relatorio-diario",
    label: "Relatório Diário da Clínica",
    esconderData: false, // Usar apenas data inicial como data específica
    apenasDataInicial: true, // Relatório de um único dia: esconder a data final
  },
  {
    value: "contabilidadeAnalitica",
    label: "Contabilidade Analítica",
    esconderData: false,
  },
  {
    value: "procedimentosExecutados",
    label: "Procedimentos Executados",
    esconderData: false,
  },
];

// Definição de quais relatórios suportam quais ações
const relatorioCaps = {
  // "procedimentos-categoria": { gerar: true, exportar: true },
  // "eficiencia-medicos": { gerar: true, exportar: true },
  // "procedimentos-pendentes": { gerar: true, exportar: false },
  // "procedimentos-medico": { gerar: true, exportar: true },
  "relatorio-diario": { gerar: true, exportar: true },
  contabilidadeAnalitica: { gerar: true, exportar: true },
  procedimentosExecutados: { gerar: true, exportar: true },
};

function RelatoriosPlanosTratamento({ clinica, auth }) {
  const { startLoading, stopLoading } = useLoading();
  const { sendRequest } = useHttpClient();
  const [dadosClinica, setDadosClinica] = useState();
  const [dadosRelatorio, setDadosRelatorio] = useState({
    open: "",
    dataFiltro: {},
    acao: "",
    filtrosAdicionais: {
      ocultarVazios: true,
      incluirDesativados: false,
    },
    //Contador para forçar a atualização
    atualizacoes: 0,
  });

  useEffect(() => {
    const fetchDadosClinica = async () => {
      startLoading();
      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/clinicas/${clinica.clinica._id}`,
          "GET",
          null,
          {
            Authorization: "Bearer " + auth.token,
          },
        );
        setDadosClinica(responseData.clinica);
      } catch (err) {
        console.error("err", err);
      } finally {
        stopLoading();
      }
    };
    fetchDadosClinica();
  }, [auth.perm, auth.token, sendRequest]);

  const gerarRelatorioHandler = (dataInicial, dataFinal, tipoRelatorio) => {
    if (!tipoRelatorio) {
      // Alerta se nenhum tipo de relatório for selecionado
      toast.error("Por favor, selecione um tipo de relatório.");
      return;
    }

    setDadosRelatorio((prevState) => ({
      open: tipoRelatorio,
      dataFiltro: { dataInicial: dataInicial, dataFinal: dataFinal },
      acao: "gerar",
      atualizacoes: prevState.atualizacoes + 1,
    }));
  };

  const exportarFicheiroHandler = (dataInicial, dataFinal, tipoRelatorio) => {
    if (!tipoRelatorio) {
      // Alerta se nenhum tipo de relatório for selecionado
      toast.error("Por favor, selecione um tipo de relatório.");
      return;
    }

    setDadosRelatorio((prevState) => ({
      open: tipoRelatorio,
      dataFiltro: { dataInicial: dataInicial, dataFinal: dataFinal },
      acao: "exportar",
      atualizacoes: prevState.atualizacoes + 1,
    }));
  };

  // Função auxiliar para renderizar o componente de relatório correto
  const renderizarRelatorio = () => {
    const { open, dataFiltro, acao, atualizacoes } = dadosRelatorio;

    if (!open) return null;

    const props = {
      dataFiltro: dataFiltro,
      dadosClinica: dadosClinica,
      auth: auth,
      acao: acao, // Passa a ação para o componente
      atualizacoes: atualizacoes,
    };

    switch (open) {
      case "procedimento-categoria":
        return <RelatorioProcedimentosCategoria {...props} />;
      case "eficiencia-medicos":
        return <RelatorioEficienciaMedicos {...props} />;
      case "procedimentos-pendentes":
        return <RelatorioProcedimentosPendentes {...props} />;
      case "procedimentos-medico":
        return <RelatorioProcedimentosMedico {...props} />;
      case "relatorio-diario":
        return <RelatorioDiario {...props} />;
      case "contabilidadeAnalitica":
        return <RelatorioContabilidadeAnalitica {...props} />;
      case "procedimentosExecutados":
        return <RelatorioProcedimentosExecutados {...props} />;
      default:
        return null;
    }
  };

  return (
    <div>
      <FiltrosRelatorio
        tiposRelatorios={tiposRelatorios}
        gerarRelatorioHandler={gerarRelatorioHandler}
        exportarFicheiroHandler={exportarFicheiroHandler}
        relatorioCaps={relatorioCaps} // Passar as capacidades para potencialmente desabilitar botões
        // Manter o tipo de relatório selecionado
        relatorioSelecionado={dadosRelatorio.open}
      />

      {renderizarRelatorio()}
    </div>
  );
}

export default RelatoriosPlanosTratamento;
